// src/pages/CourseTime/styles/activities.styles.js
import styled from 'styled-components';

// Activity layout components
export const ActivityContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  padding: 20px;
  //max-width: 1100px;
  margin: 0 auto;
  align-items: flex-start;
    @media (max-width: 1024px) {
        flex-direction: column;
    }
`;

export const ActivityColumnContainer = styled(ActivityContainer)`
  flex-direction: column;
  align-items: center;
  max-width: 100%;
    @media (max-width: 786px) {
        padding: 30px;
    }
`;

export const ShareFileActivityContainer = styled(ActivityContainer)`
    align-items: center;
`;

export const ActivityLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ActivityRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
    @media (max-width: 768px) {
       width: 100%;
    }
    
    @media (min-width:768px) and (max-width: 830px) {
       width: 100%;
       margin-top: 0;
    }
    
    @media (min-width:830px) and (max-width: 1024px) {
       width: 50%;
    }
`;

export const ActivityJournalingRight = styled(ActivityRight)`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
    @media (max-width: 768px) {
       width: 100%;
    }
    
    @media (min-width:768px) and (max-width: 830px) {
       width: 100%;
       margin-top: 0;
    }
    
    @media (min-width:830px) and (max-width: 1024px) {
       width: 100%;
    }
`;

export const ActivityHeader = styled.div`
    width: 100%;
  text-align: center;
  //max-width: 700px;
`;

export const ActivityTitle = styled.h2`
  font-size: 42px;
  color: #EE6D29;
  font-weight: 700;
  margin-bottom: 16px;
  text-align: left;
  margin-top: 0;
    line-height: 1.2;
    @media (max-width: 1024px) {
        font-size: 33px;
    }
    @media (max-width: 768px) {
        font-size: 25px;
    }
`;

export const ActivityPollTitle = styled(ActivityTitle)`
  text-align: center;
`;

export const ActivityContent = styled.div`
  text-align: left;
  font-size: 18px;
  line-height: 1.6;
  color: #000;
  white-space: pre-line;
`;

// Journaling Activity
export const JournalingTextArea = styled.textarea`
  width: 100%;
  min-height: 400px;
  padding: 16px;
  border: 2px solid ${({ themeColor }) => themeColor || '#FF7676'};
  border-radius: 8px;
  background-color: #fff;
  font-size: 16px;
  font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;
  line-height: 1.5;
  resize: vertical;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ themeColor }) => themeColor || '#FF7676'};
    box-shadow: 0 0 0 3px rgba(255, 118, 118, 0.15);
  }

  &::placeholder {
    color: #a0aec0;
  }

  &:disabled {
    background-color: #f5f5f5;
    border-color: #ddd;
    color: #666;
    cursor: not-allowed;
    
    &::placeholder {
      color: #ccc;
    }
  }
`;

// Share work activity styles
export const Text = styled.div`
  text-align: center;
  font-weight: 600;
  color: #000000;
  margin: 10px auto;
  font-size: 22px;
`;

export const LinkInput = styled.input`
  width: 100%;
  height: 85px;
  margin: 10px auto;
  padding: 0 12px 12px 12px;
  border: 2px solid ${({ themeColor }) => themeColor || '#0097B2'};
  border-radius: 8px;
  background-color: #fff !important;
  font-size: 16px;
  font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;
  line-height: 1.5;
  resize: vertical;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ themeColor }) => themeColor || '#0097B2'};
    box-shadow: 0 0 0 3px rgba(255, 118, 118, 0.15);
  }

    &::placeholder {
    color: #a0aec0;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    }

    &:disabled {
    background-color: #f5f5f5 !important;
    border-color: #ddd;
    color: #666;
    cursor: not-allowed;
    
    &::placeholder {
      color: #ccc;
    }
  }

    @media (max-width: 768px) {
      width: 100%;
    }
`;

export const FileUploadButton = styled.button`
  padding: 10px 20px;
  background-color: ${({ themeColor }) => themeColor || '#0097B2'};
  border: none;
  border-radius: 6px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  margin: 10px auto;
  width: 60%;
  transition: all 0.2s ease;
  &:hover {
    background-color: ${({ themeColor }) => themeColor || '#0097B2'};
    filter: brightness(0.9);
  }
`;

// Poll/Quiz activity styles — same vertically-stacked, full-width row layout
// as AssessmentSlide's OptionsList/OptionCard/OptionBadge, just kept in the
// poll's own themeColor instead of the assessment's fixed accent.
export const PollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
`;

export const PollOption = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 16px 24px;
  border: 1.5px solid ${props => (props.selected ? (props.themeColor || '#0097B2') : '#e3e5e8')};
  border-radius: 12px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;

  /* Keep selected colors even when disabled for better UX */
  background-color: ${props => (props.selected ? `${props.themeColor || '#0097B2'}14` : '#fff')};

  /* Add opacity overlay when disabled to show it's not interactive */
  ${props => props.disabled && !props.selected && `
    background-color: #f5f5f5;
    color: #999;
    border-color: #ddd;
  `}
  
  /* Add subtle overlay for disabled selected items */
  ${props => props.disabled && props.selected && `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.1);
      border-radius: 10px;
      pointer-events: none;
    }
  `}

  &:hover {
    border-color: ${props => {
      const color = props.themeColor || '#0097B2';
      if (props.disabled) return props.selected ? color : '#ddd';
      return color;
    }};
  }
`;

export const PollOptionBadge = styled.div`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1.5px solid ${props => (props.selected ? (props.themeColor || '#0097B2') : '#c7cbd1')};
  background-color: ${props => (props.selected ? (props.themeColor || '#0097B2') : 'transparent')};
  color: ${props => (props.selected ? '#fff' : '#9aa0a6')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
`;

export const PollOptionText = styled.span`
  flex: 1;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  color: #2b2f36;
`;

// Common button styles
export const SubmitButton = styled.button`
  align-self: center;
  padding: 12px 32px;
  background-color: #FF7676;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 16px;
  
  &:hover {
    background-color: #FF7676;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    background-color: #DDDDDD;
    cursor: not-allowed;
    transform: none;
  }
`;

export const SaveButton = styled(SubmitButton)`
  background-color: #FF7676;
  
  &:hover {
    background-color: #FF7676;
  }
  
  &:disabled {
    background-color: #DDDDDD;
  }
`;

// Discussion Activity button
export const DiscussionButton = styled.button`
  padding: 16px 40px;
  background-color: ${({ themeColor }) => themeColor || '#0097B2'};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 24px;
  margin-bottom: 16px;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  &:hover {
    background-color: ${({ themeColor }) => themeColor || '#0097B2'};
    filter: brightness(0.85);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 151, 178, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    background-color: #DDDDDD;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
  
  /* Add icon styling */
  i {
    font-size: 16px;
  }
`;

// Loading overlay for activities
export const ActivityLoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;
`;

export const LoadingSpinner = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid #FF7676;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LoadingText = styled.div`
  margin-left: 12px;
  font-size: 16px;
  color: #666;
  font-weight: 500;
`;

// Wrapper for activity components with loading state
export const ActivityWrapper = styled.div`
  position: relative;
  width: 100%;
`;

// Wrapper for response saved indicator and edit button
export const ResponseSavedWrapper = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const ResponseSavedIndicator = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
`;

export const EditButton = styled.button`
  padding: 4px;
  background-color: transparent;
  color: ${({ themeColor }) => themeColor || '#EE6D29'};
  border-radius: 999px;
  border: none;
  font-size: 16px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  /* Flip pencil to be right-facing */
  i {
    transform: scaleX(-1);
  }
  
  &:hover {
    background-color: ${({ themeColor }) => themeColor ? `${themeColor}14` : 'rgba(238, 109, 41, 0.08)'};
  }
`;

// Inline action button used for "View poll results" and "Edit response"
export const PollActionButton = styled.button`
  padding: 10px 24px;
  background-color: ${({ $variant }) =>
    $variant === 'pink' ? '#FF7676' : '#0097B2'};
  color: #ffffff;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${({ $variant }) =>
      $variant === 'pink' ? '#ff5a5a' : '#007A94'};
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;


export const PollIcon = styled.i`
  font-size: 17px;
  /* Use three high-contrast colors from poll chart palette (no orange) */
  background: conic-gradient(
    #7395cc 0 33.3%,   /* dark blue */
    #3ac5f3 33.3% 66.6%, /* light blue */
    #018fa6 66.6% 100%   /* teal */
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

// Modal Styles
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
`;

export const ModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${({ themeColor }) => themeColor || '#EE6D29'};
  text-align: center;
  margin: 0;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 32px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f3f4f6;
    color: #374151;
  }
`;

export const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
`;

export const ModalFooterNote = styled.p`
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  text-align: center;
`;

export const ModalLoading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
`;

export const ErrorIcon = styled.div`
  font-size: 48px;
`;

export const ErrorMessage = styled.p`
  font-size: 16px;
  color: #6b7280;
  text-align: center;
  margin: 0;
  max-width: 400px;
`;

export const RetryButton = styled.button`
  padding: 8px 16px;
  background-color: ${({ themeColor }) => themeColor || '#0097B2'};
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, filter 0.2s ease;
  
  &:hover {
    background-color: ${({ themeColor }) => themeColor || '#0097B2'};
    filter: brightness(0.85);
  }
`;

// Chart Styles
export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const ChartTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  text-align: center;
  line-height: 1.4;
  max-width: 600px;
`;

export const ChartSubtitle = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  text-align: center;
`;

export const ChartWrapper = styled.div`
  display: flex;
  gap: 40px;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

export const PieChart = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
  }
`;

export const PieSlice = styled.path`
  transition: all 0.2s ease;
  cursor: pointer;
  
  &:hover {
    transform: scale(1.02);
    filter: brightness(1.1);
  }
`;

export const ChartLegend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 250px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #f3f4f6;
  }
`;

export const LegendColor = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 3px;
  background-color: ${props => props.color};
  flex-shrink: 0;
`;

export const LegendText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;

export const LegendLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  line-height: 1.2;
`;

export const LegendStats = styled.span`
  font-size: 12px;
  color: #6b7280;
`;

export const NoDataMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  font-size: 16px;
  color: #6b7280;
  text-align: center;
`;
